import { Component, OnInit, ViewChild, AfterViewInit, ElementRef, OnDestroy } from '@angular/core';
import { LayoutService } from './service/layout.service';
import { AccountService } from '../accounts/service/account.service';
import { NotificationType } from '../accounts/model/NotificationType';
import { CustomErrorHandler } from './service/CustomErrorHandler';
import { Router } from '@angular/router';
import { CaseSplitPipe } from '../shared/pipe/CaseSplit.pipe';

@Component({
    templateUrl: './premisesNotification.component.html',
    styleUrls: ['../revalidation/list.scss'],
    standalone: false
})
export class PremisesNotificationComponent implements AfterViewInit, OnInit, OnDestroy {

  NotificationType = NotificationType;
  loading = false;
  searchVisible = true;
  notifications;
  ownerName: string | null = null;
  errorMessage: string | null = null;
  ownerNumber: string | null = null;
  ownerId: string | null = null;
  loadingDetails: boolean | null = null;
  exitToDetailsPage: boolean = false;
  
  @ViewChild('ownerNo') ownerNumberRef: ElementRef;

  constructor(
    public layout: LayoutService,
    public account: AccountService,
    public error: CustomErrorHandler,
    private router: Router
  ) { }

  search() {
    if(this.ownerNumber) {
    this.fetchNotifications();
    }
  }

  fetchNotifications(){
    if(this.ownerNumber) {
      this.loading = true;
      this.account.getPremisesNotifications(this.ownerNumber).subscribe(
          notificationsData => {
            this.setNotificationsDetails(true,{owner: { ownerId:notificationsData.recipient.ownerId, ownerName: notificationsData.recipient.ownerName, ownerNumber:notificationsData.recipient.ownerNumber}, notifications: notificationsData.notifications.data});
            this.loading = false;
          },
          error => {
            this.setNotificationsDetails(false,{owner: { ownerId: null, ownerName: null, ownerNumber:null},notifications:[]});
            this.loading = false;
            this.errorMessage = 'Error in fetching the details';
            if(error.status === 404) this.errorMessage = 'No details found';
          }
      );
    }
  }

  setNotificationsDetails(status: boolean, details: {owner: { ownerId:string | null, ownerName: string | null, ownerNumber:string | null}, notifications}) {
    if(status) {
      this.ownerId = details.owner.ownerId;
      this.ownerName = details.owner.ownerName;
      this.notifications = details.notifications;
    } else {
      this.ownerName = '';
      this.notifications = [];
    }
    
  }

  ngOnInit(): void {
    if(!this.ownerNumber) {
      this.ownerNumber = this.account.ownerNumberToSearch;
      this.fetchNotifications();
    }
  }

  ngAfterViewInit() {
    this.setFocus();
  }

  setFocus() {
    if (this.searchVisible) {
      setTimeout(() => {
        this.ownerNumberRef.nativeElement.focus();
      });
    }
  }

  viewNotificationDetails(rowNumber) {
    this.loadingDetails = false;
    let updatedPremisesNotification = {ownerNumber: this.ownerNumber,ownerId: this.ownerId,notifications: this.notifications, row: rowNumber};
    this.account.premisesNotificationType$.next(updatedPremisesNotification);

    this.exitToDetailsPage = true;
    this.router.navigate(['/premises/notification/details']);
  }

  showSearch() {
    this.searchVisible = !this.searchVisible;
  }

  clearSearch() {
    this.ownerNumber = '';
    this.notifications = '';
    this.errorMessage = null;
    this.loading = false;
  }

  getNotificationType(notificationType: NotificationType) {

    const caseSplitPipe = new CaseSplitPipe();

    if(notificationType) {
    if (notificationType === NotificationType.RenewalWindowOpeningForPharmacyForCardBACS) {
      return 'Renewal window opening for pharmacy for Card/BACS';
    }
    if (notificationType === NotificationType.PharmacyRenewalDeclarationReminderForDD) {
      return 'Pharmacy renewal declaration reminder for DD';
    }
    if (notificationType === NotificationType.PharmacyRenewalDeclarationMissedForDD) {
      return 'Pharmacy renewal declaration missed for DD';
    }
    if (notificationType === NotificationType.PharmacyRenewalPaymentSubmittedForBACS) {
      return 'Pharmacy renewal payment submitted for BACS';
    }
      return caseSplitPipe.transform(NotificationType[notificationType]);
    }
  }

  ngOnDestroy(): void {
    if(this.exitToDetailsPage) this.account.ownerNumber$.next(this.ownerNumber);
    else this.account.ownerNumber$.next(null);
  }

}
